import api from './axiosConfig';

export type MarketIndexPoint = {
  at: string;
  indexValue: number | null;
  changeValue: number | null;
  changeRate: number | null;
  cumTradingValue: number | null;
  cumVolume: number | null;
  lastEventAt: string | null;
  provider: string | null;
};

export type MarketDerivativePoint = {
  at: string;
  sessionType: 'REGULAR' | 'NIGHT' | string;
  contractCode: string | null;
  contractName: string | null;
  futuresPrice: number | null;
  futuresChange: number | null;
  futuresChangeRate: number | null;
  marketBasis: number | null;
  openInterest: number | null;
  sessionOpenInterest: number | null;
  oiChangeCumulative: number | null;
  oiChange1m: number | null;
  oiChange5m: number | null;
  oiChange15m: number | null;
  oiBaselineSource: string | null;
  lastEventAt: string | null;
};

export type MarketGlobalFuturesPoint = {
  at: string;
  symbol: 'NQ' | 'ES' | 'ZN' | string;
  value: number | null;
  changeRate: number | null;
  sourceStatus: string | null;
};

export type MarketIntradayResponse = {
  provider: 'KIS' | string;
  sourcePolicy: string;
  sessionReference: string;
  dataStatus: 'OK' | 'PARTIAL' | 'NO_DATA' | string;
  globalDataStatus?: 'AVAILABLE' | string;
  tradeDate: string | null;
  cashTradeDate: string | null;
  cashMarketState?: 'CURRENT_KRX_TRADE_DATE' | 'LAST_KRX_CLOSE' | 'NO_DATA' | string;
  indices: {
    KOSPI: MarketIndexPoint[];
    KOSDAQ: MarketIndexPoint[];
  };
  derivatives: {
    KOSPI200: MarketDerivativePoint[];
    KOSDAQ150: MarketDerivativePoint[];
  };
  globalFutures?: Partial<{
    NQ: MarketGlobalFuturesPoint[];
    ES: MarketGlobalFuturesPoint[];
    ZN: MarketGlobalFuturesPoint[];
  }>;
  participantFlow: {
    dataStatus: string;
    reason?: string;
  };
};

export async function getMarketIntraday(
    tradeDate?: string,
): Promise<MarketIntradayResponse> {
  const params = tradeDate ? {tradeDate} : undefined;
  const response = await api.get<MarketIntradayResponse>(
      '/live-summary/market/intraday',
      {params},
  );
  return response.data;
}
